
export default {
  name: 'MenuSpacer'
};
